<template>
  <div class="page page__list">
    <search-bar
      @search="onSearchWithId"
      name="pr_detail,pi_vendname,pi_seller"
      placeholder="输入物料、供应商、人员进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearchWithId" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearchWithId" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="(item, index) in items"
        :key="index"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{ item.bizname }}</p>
          <p>{{ item.pd_ordercode }}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">
            {{ item.pi_date }}
          </p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.pr_detail }}</p>
          <p>
          <span v-format="'#,##0.#'">{{ item.ordertotal }}</span>&nbsp;{{ item.pi_currency }}
          </p>
          <p class="list-item-muted">{{ item.emname }}</p>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{ items.length }}单</label>
      <em class="list-footer__value">
        合计：
        <span v-format="'#,##0.00'">{{ getTotal() }}</span
        >元
      </em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/storage/report/purchaseIn",
      params: {
        mode: "DETAIL",
        number: 1,
        size: 20,
        calculateFields: JSON.stringify([
          { field: "inqty", operation: "sum" },
          { field: "pi_currency", operation: "max" },
          { field: "taxamount", operation: "sum" },
          { field: "nettotal", operation: "sum" },
          { field: "ordertotal", operation: "sum" },
        ]),
        queryId: 5279527952795279,
        page: 1,
        start: 0,
        limit: 99999,
      },
      filters: [
        {
          type: "date",
          name: "pi_date",
        },
        {
          type: "currency",
          name: "pi_currency"
        }
      ],
    };
  },
  methods: {
    onSearchWithId(callback) {
      this.params.queryId = Math.random().toString(36);
      this.onSearch(callback);
    },
    gotoView(item) {
      this.$router.push({
        name: "PurchasePurchaseinReportDetail",
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
    getTotal() {
      var me = this,
        items = me.items,
        total = 0;
      items.forEach((item) => {
        total += item.ordertotal;
      });
      return total;
    },
    getCondition() {
      var me = this,
        filterBar = me.$refs.filterBar,
        filterCondition = filterBar ? filterBar.getCondition() : [],
        searchBar = me.$refs.searchBar,
        searchCondition = searchBar ? searchBar.getCondition() : null;
      if (searchCondition) {
        filterCondition.push(searchCondition);
      }
      filterCondition.push({
        type: "condition",
        value: " pi_class in( 'PURCIN','PURCOUT')  and PI_STATUS='已审核'",
      });
      return filterCondition;
    },
  },
};
</script>